import { useEffect, useState } from 'react';
import CustomAppBar from '../../components/CustomAppBar';
import { Box, Card, Container, Typography, CircularProgress } from "@mui/material";
import { connect, useDispatch } from 'react-redux';
import { fatafatDollarActions } from '../../store/reducer/fatafat-dollar';

const DollarRates = ({ isFatafatDollarLoading, fatafatDollarGameRateData }: any) => {
    const dispatch = useDispatch();
    const [gameRates, setGameRates] = useState<any>([]);

    useEffect(() => {
        const data: any = {
            app_key: "@34Y@#8deepmatka",
        };
        dispatch(fatafatDollarActions.fatafatDollarGameRatesReq(data));
    }, []);

    useEffect(() => {
        if (fatafatDollarGameRateData && fatafatDollarGameRateData.game_rates) {
            const rates = fatafatDollarGameRateData.game_rates;
            
            // Create game rates array with proper formatting
            const ratesArray = [
                {
                    name: 'Ankda/Single Ank',
                    rate: rates.single_digit_val_2 || 0,
                    displayRate: `1 ka ${rates.single_digit_val_2 || 0}`
                },
                {
                    name: 'Jodi',
                    rate: rates.jodi_digit_val_2 || 0,
                    displayRate: `1 ka ${rates.jodi_digit_val_2 || 0}`
                },
                {
                    name: 'SP Pana',
                    rate: rates.single_pana_val_2 || 0,
                    displayRate: `1 ka ${rates.single_pana_val_2 || 0}`
                },
                {
                    name: 'DP Pana',
                    rate: rates.double_pana_val_2 || 0,
                    displayRate: `1 ka ${rates.double_pana_val_2 || 0}`
                },
                {
                    name: 'Tripple Pana',
                    rate: rates.tripple_pana_val_2 || 0,
                    displayRate: `1 ka ${rates.tripple_pana_val_2 || 0}`
                },
                {
                    name: 'Motor SP',
                    rate: rates.single_pana_val_2 || 0, // SP Motor uses SP Pana rate
                    displayRate: `1 ka ${rates.single_pana_val_2 || 0}`
                },
                {
                    name: 'Motor DP',
                    rate: rates.double_pana_val_2 || 0, // DP Motor uses DP Pana rate
                    displayRate: `1 ka ${rates.double_pana_val_2 || 0}`
                },
                {
                    name: 'Jackpot',
                    rate: rates.jackpot_val_2 || 0,
                    displayRate: `1 ka ${rates.jackpot_val_2 || 0}`
                }
            ];
            
            setGameRates(ratesArray);
        }
    }, [fatafatDollarGameRateData]);

    return (
        <div>
            <CustomAppBar title={'Dollar Game Rate'} isBack={true} />
            {isFatafatDollarLoading ? 
                <div style={{ width: '100%', height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}> 
                    <CircularProgress /> 
                </div> :
                <Container sx={{ 
                    paddingLeft: '0px !important', 
                    paddingRight: '0px !important', 
                    marginTop: '70px !important', 
                    paddingBottom: '50px',
                    background: 'linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%)',
                    minHeight: '100vh'
                }}>
                    <Box sx={{ padding: '20px' }}>
                        <Typography 
                            variant="h4" 
                            sx={{ 
                                color: 'white', 
                                textAlign: 'center', 
                                marginBottom: '30px',
                                fontWeight: 'bold',
                                textShadow: '2px 2px 4px rgba(0,0,0,0.5)'
                            }}
                        >
                            Dollar Game Rates
                        </Typography>
                        
                        <Card sx={{ 
                            background: 'rgba(255,255,255,0.1)', 
                            backdropFilter: 'blur(10px)',
                            borderRadius: '15px',
                            padding: '20px',
                            border: '1px solid rgba(255,255,255,0.2)'
                        }}>
                            {gameRates.map((item: any, index: number) => (
                                <Box key={index}>
                                    <Box sx={{ 
                                        display: 'flex', 
                                        justifyContent: 'space-between', 
                                        alignItems: 'center',
                                        padding: '15px 20px',
                                        background: 'rgba(255,255,255,0.05)',
                                        borderRadius: '10px',
                                        marginBottom: '10px',
                                        border: '1px solid rgba(255,255,255,0.1)'
                                    }}>
                                        <Typography 
                                            sx={{ 
                                                color: 'white', 
                                                fontSize: '1.1rem', 
                                                fontWeight: '600',
                                                textShadow: '1px 1px 2px rgba(0,0,0,0.3)'
                                            }}
                                        >
                                            {item.name}
                                        </Typography>
                                        <Box sx={{
                                            background: 'linear-gradient(45deg, #FFD700, #FFA500)',
                                            color: '#000',
                                            padding: '8px 16px',
                                            borderRadius: '20px',
                                            fontWeight: 'bold',
                                            fontSize: '1rem',
                                            boxShadow: '0 4px 8px rgba(255,215,0,0.3)',
                                            border: '2px solid #FFD700'
                                        }}>
                                            {item.displayRate}
                                        </Box>
                                    </Box>
                                    {index < gameRates.length - 1 && (
                                        <Box sx={{ 
                                            height: '1px', 
                                            background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent)',
                                            margin: '5px 0'
                                        }} />
                                    )}
                                </Box>
                            ))}
                        </Card>
                        
                        <Box sx={{ 
                            marginTop: '30px', 
                            textAlign: 'center',
                            background: 'rgba(255,255,255,0.1)',
                            padding: '20px',
                            borderRadius: '15px',
                            border: '1px solid rgba(255,255,255,0.2)'
                        }}>
                            <Typography sx={{ 
                                color: 'white', 
                                fontSize: '1rem',
                                opacity: 0.8
                            }}>
                                All rates are subject to change. Please check before placing bets.
                            </Typography>
                        </Box>
                    </Box>
                </Container>
            }
        </div>
    );
};

const mapStateToProps = (state: any) => ({
    isFatafatDollarLoading: state.fatafatdollar.isFatafatDollarLoading,
    fatafatDollarGameRateData: state.fatafatdollar.fatafatDollarGameRateData,
});

export default connect(mapStateToProps)(DollarRates);
